import { PastActionsList } from "./PastActionsList";

export default PastActionsList;
